module.exports = __webpack_public_path__ + "img/logo-momo-4.56f3b1fe.jpg";